export default function SFWalletOutlinedIcon({}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 8H17C18.6569 8 20 9.34315 20 11V18C20 19.6569 18.6569 21 17 21H6C4.34315 21 3 19.6569 3 18V11C3 9.34315 4.34315 8 6 8Z"
        stroke="#8B8B8B"
        strokeWidth="2"
      />
      <mask id="path-2-inside-1_99_2179" fill="white">
        <path d="M2 12.3644V7.79445C2 6.60445 2.73 5.54441 3.84 5.12441L11.78 2.12441C13.02 1.65441 14.35 2.57444 14.35 3.90444V7.70442" />
      </mask>
      <path
        d="M0 12.3644C0 13.469 0.89543 14.3644 2 14.3644C3.10457 14.3644 4 13.469 4 12.3644H0ZM3.84 5.12441L3.13311 3.2535L3.13222 3.25383L3.84 5.12441ZM11.78 2.12441L12.4869 3.99532L12.4889 3.99457L11.78 2.12441ZM12.35 7.70442C12.35 8.80899 13.2454 9.70442 14.35 9.70442C15.4546 9.70442 16.35 8.80899 16.35 7.70442H12.35ZM4 12.3644V7.79445H0V12.3644H4ZM4 7.79445C4 7.43197 4.21923 7.11929 4.54778 6.99498L3.13222 3.25383C1.24077 3.96952 0 5.77693 0 7.79445H4ZM4.54689 6.99532L12.4869 3.99532L11.0731 0.253496L3.13311 3.2535L4.54689 6.99532ZM12.4889 3.99457C12.4802 3.99784 12.4585 4.00217 12.4334 3.99874C12.4125 3.99588 12.3992 3.98911 12.3916 3.98379C12.3839 3.97847 12.3736 3.96894 12.3643 3.95174C12.353 3.93096 12.35 3.91114 12.35 3.90444H16.35C16.35 1.18116 13.6254 -0.713924 11.0711 0.254238L12.4889 3.99457ZM12.35 3.90444V7.70442H16.35V3.90444H12.35Z"
        fill="#8B8B8B"
        mask="url(#path-2-inside-1_99_2179)"
      />
      <path
        d="M15.0124 14.722L15.0124 14.722L15.0113 14.7099C14.938 13.9616 15.2286 13.2518 15.7575 12.7494C15.7636 12.7436 15.7697 12.7377 15.7757 12.7317C16.2332 12.2745 16.872 12 17.5956 12H21.2249C21.6997 12.0234 22 12.3828 22 12.7414V16.2586C22 16.6172 21.6997 16.9766 21.2249 17H17.8061C16.328 17 15.1178 15.9526 15.0124 14.722Z"
        fill="white"
        stroke="#8B8B8B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 12H12"
        stroke="#8B8B8B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
